import draggable from 'vuedraggable'

var mixin = {
  components: {
    draggable
  }
}

export default mixin;
